var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { SectionFieldPath } from './models/section';
import { ArticleFieldPath } from './models/article';
import { UserRole } from './models';
function draftSuffix(collectionName, isDraft) {
    return isDraft ? collectionName + 'Draft' : collectionName;
}
var excludeDeletedItemsFilter = function (obj) { return !obj.data().deleted; };
var Collection;
(function (Collection) {
    Collection["Project"] = "project";
    Collection["Platform"] = "platform";
    Collection["Resources"] = "resources";
    Collection["Category"] = "category";
    Collection["Section"] = "section";
    Collection["Article"] = "article";
    Collection["Invocation"] = "invocation";
    Collection["UploadedImage"] = "uploadedImage";
    Collection["Configuration"] = "configuration";
    Collection["EXTERNAL"] = "externals";
    Collection["Features"] = "_features";
    Collection["AccessRoles"] = "accessRoles";
    Collection["Chief"] = "chief";
    Collection["Changelog"] = "changelog";
})(Collection || (Collection = {}));
var Invocation;
(function (Invocation) {
    Invocation["Delete"] = "delete";
    Invocation["PublishProcess"] = "publishProcess";
    Invocation["PinProtect"] = "pinProtect";
    Invocation["ProtectCategory"] = "protectCategory";
    Invocation["ChangeStaffCredentials"] = "changeStaffCredentials";
    Invocation["ChangeAccountCredentials"] = "changeAccountCredentials";
})(Invocation || (Invocation = {}));
var Document;
(function (Document) {
    Document["SubscribeNotification"] = "subscribe-notifications";
})(Document || (Document = {}));
var StoreService = /** @class */ (function () {
    function StoreService(store, projectName, isDraft, user) {
        if (isDraft === void 0) { isDraft = false; }
        if (user === void 0) { user = null; }
        this.store = store;
        this.projectID = projectName;
        this.isDraft = isDraft;
        this.user = __assign({}, user);
        this.projectRef = store.collection(Collection.Project).doc(projectName);
        this.articleCollectionRef = this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft));
        this.categoryCollectionRef = this.projectRef.collection(draftSuffix(Collection.Category, this.isDraft));
        this.chiefCategoryRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Category);
        this.chiefSectionRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Section);
        this.chiefArticleRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Article);
        this.changelogSectionRef = this.projectRef
            .collection(Collection.Changelog)
            .doc('db')
            .collection(Collection.Section);
        this.changelogArticleRef = this.projectRef
            .collection(Collection.Changelog)
            .doc('db')
            .collection(Collection.Article);
    }
    /**
     *
     * @param userRole
     * @param categoryPermissions
     * @returns {string[]} permittedCategories
     */
    StoreService.prototype.initPermittedCategories = function (userRole, categoryPermissions) {
        return __awaiter(this, void 0, void 0, function () {
            var categories, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] initPermittedCategories called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchAllCategories()];
                    case 2:
                        categories = _a.sent();
                        if (userRole === UserRole.ADMIN || userRole === UserRole.SUPER_ADMIN) {
                            this.permittedCategories = categories.map(function (c) { return c.id; });
                        }
                        else if (userRole === UserRole.STAFF) {
                            this.permittedCategories = categories
                                .filter(function (c) { return !c.data().isProtected; })
                                .map(function (c) { return c.id; })
                                .concat(categoryPermissions);
                        }
                        else if (userRole === UserRole.NONE) {
                            this.permittedCategories = categories.filter(function (c) { return !c.data().isProtected; }).map(function (c) { return c.id; });
                        }
                        else {
                            this.permittedCategories = [];
                        }
                        return [2 /*return*/, this.permittedCategories];
                    case 3:
                        e_1 = _a.sent();
                        console.log('[@core/StoreService] initPermittedCategories error:', e_1);
                        this.permittedCategories = [];
                        return [2 /*return*/, this.permittedCategories];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    //
    // Project
    //
    // fetchProjectConfig returns the project configuration, as deployed to firebase using eir-cli deploy configuration.
    StoreService.prototype.fetchProjectConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProjectConfig called');
                        return [4 /*yield*/, this.store.doc('configuration/project').get()];
                    case 1:
                        doc = _a.sent();
                        return [2 /*return*/, doc.data()];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProjectFeatures called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.Features).doc('enabled').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc === null || !doc.exists) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProject = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProject called');
                        return [4 /*yield*/, this.projectRef.get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.updateProjectConfiguration = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] updateProjectConfiguration called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.Configuration).doc('draft').update(config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // in web we depend on configuration document entity (not on project entity)
    StoreService.prototype.fetchProjectConfigurationDoc = function (isDraft) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProjectConfigurationDoc called');
                        return [4 /*yield*/, this.projectRef
                                .collection(Collection.Configuration)
                                .doc(isDraft ? 'draft' : 'published')
                                .get()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StoreService.prototype.fetchAllCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var snapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchAllCategories called');
                        return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Category, this.isDraft)).get()];
                    case 1:
                        snapshot = _a.sent();
                        return [2 /*return*/, snapshot.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchAllData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fetchProject, fetchLegalDocuments, fetchProjectMetadata, fetchPlatformMetadata, fetchCollections, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchAllData called');
                        fetchProject = this.fetchProject();
                        fetchLegalDocuments = this.fetchLegalDocuments();
                        fetchProjectMetadata = [this.fetchProjectJs(), this.fetchProjectCss()];
                        fetchPlatformMetadata = [this.fetchPlatformJs(), this.fetchPlatformCss()];
                        fetchCollections = [
                            Collection.Category,
                            Collection.Section,
                            Collection.Article,
                        ].map(function (type) { return _this.projectRef.collection(draftSuffix(type, _this.isDraft)).get(); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(__spreadArrays([
                                fetchProject,
                                fetchLegalDocuments
                            ], fetchCollections, fetchProjectMetadata, fetchPlatformMetadata))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.warn('Failed to fetch Firestore data:', e_2.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchLegalDocuments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchLegalDocuments called');
                        return [4 /*yield*/, this.store.collection(Collection.Platform).doc('legalDocuments').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch legal documents');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProjectCss called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('CSS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectJs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchProjectJs called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('JS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project JS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchPlatformJs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchPlatformJs called');
                        return [4 /*yield*/, this.store.collection(Collection.Platform).doc('JS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch platform JS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchPlatformCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchPlatformCss called');
                        return [4 /*yield*/, this.store.collection(Collection.Platform).doc('CSS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch platform CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.chunk = function (data, chunkSize) {
        console.log('[@core/StoreService] chunk called');
        return Array.from(Array(Math.ceil(data.length / chunkSize))).map(function (_, index) {
            return data.slice(index * chunkSize, Math.min(data.length, (index + 1) * chunkSize));
        });
    };
    // For bookmarks
    StoreService.prototype.fetchChiefArticleList = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, fetchArticles, _a, _b, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefArticleList called');
                        chunks = this.chunk(ids, 10);
                        fetchArticles = chunks.map(function (chunk) {
                            return _this.chiefArticleRef
                                .where('__name__', 'in', chunk)
                                .get()
                                .then(function (queries) { return queries.docs; })
                                .catch(function (e) {
                                console.error(e);
                                return [];
                            });
                        });
                        _b = (_a = [].concat).apply;
                        _c = [[]];
                        return [4 /*yield*/, Promise.all(fetchArticles)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.sent())]))];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticleList = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, fetchArticles, _a, _b, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChangelogArticleList called');
                        chunks = this.chunk(ids, 10);
                        fetchArticles = chunks.map(function (chunk) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, this.changelogArticleRef
                                        .where('__name__', 'in', chunk)
                                        .get()
                                        .then(function (queries) {
                                        return queries.docs;
                                    })
                                        .catch(function (e) {
                                        console.log(e);
                                        return [];
                                    })];
                            });
                        }); });
                        _b = (_a = [].concat).apply;
                        _c = [[]];
                        return [4 /*yield*/, Promise.all(fetchArticles)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.sent())]))];
                }
            });
        });
    };
    StoreService.prototype.fetchArticleList = function (ids, role, permittedCategories) {
        return __awaiter(this, void 0, void 0, function () {
            var chief, changelog, regular;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchArticleList called', role, permittedCategories);
                        chief = [];
                        changelog = [];
                        return [4 /*yield*/, this.fetchAllArticles()];
                    case 1:
                        regular = (_a.sent()).filter(function (a) { return ids.includes(a.id); });
                        if (!(role === UserRole.ADMIN || role === UserRole.SUPER_ADMIN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchChiefArticleList(ids)];
                    case 2:
                        chief = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!permittedCategories.includes('changelog')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.fetchChangelogArticleList(ids)];
                    case 4:
                        changelog = _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, regular.concat(chief, changelog)];
                }
            });
        });
    };
    StoreService.prototype.publish = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] publish called');
                        return [4 /*yield*/, this.store
                                .collection(Collection.Invocation)
                                .doc(Invocation.PublishProcess)
                                .collection('i_project')
                                .doc(this.projectID)
                                .collection(this.user.uid)
                                .doc()];
                    case 1:
                        doc = _a.sent();
                        return [4 /*yield*/, (data.notifyMessage.trim() !== '' ? doc.set(data) : doc.set({}))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, doc.get()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StoreService.prototype.fetchAllArticles = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var collectionPath, ids, batches, batch, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (((_a = this.permittedCategories) === null || _a === void 0 ? void 0 : _a.length) < 1)
                            return [2 /*return*/, []];
                        collectionPath = this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft));
                        ids = __spreadArrays(this.permittedCategories);
                        batches = [];
                        while (ids.length > 0) {
                            batch = ids.splice(0, 10);
                            batches.push(collectionPath
                                .where('category', 'in', __spreadArrays(batch))
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()
                                .then(function (query) { return query.docs.filter(excludeDeletedItemsFilter); }));
                        }
                        _c = (_b = [].concat).apply;
                        _d = [[]];
                        return [4 /*yield*/, Promise.all(batches)];
                    case 1: return [2 /*return*/, _c.apply(_b, _d.concat([(_e.sent())]))];
                }
            });
        });
    };
    StoreService.prototype.fetchAllImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchAllImages called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.UploadedImage).get()];
                    case 1: return [2 /*return*/, (_a.sent()).docs];
                }
            });
        });
    };
    StoreService.prototype.fetchFroalaCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchFroalaCss called');
                        return [4 /*yield*/, this.store.collection(Collection.Platform).doc('froalaCSS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchExternal = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchExternal called');
                        return [4 /*yield*/, this.projectRef.collection(Collection.EXTERNAL).doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChangelogArticle called');
                        return [4 /*yield*/, this.changelogArticleRef.doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefArticle called');
                        return [4 /*yield*/, this.chiefArticleRef.doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchArticle called');
                        return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft)).doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchCategoryFromRegularArticleId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc, categoryId, doc2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchCategoryFromRegularArticleId called');
                        return [4 /*yield*/, this.projectRef
                                .collection('aggregatedHelpers')
                                .doc('publicArticleData')
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch public article data for '" + id + "'");
                        }
                        categoryId = doc.data()[id].category;
                        return [4 /*yield*/, this.projectRef
                                .collection(draftSuffix(Collection.Category, this.isDraft))
                                .doc(categoryId)
                                .get()];
                    case 2:
                        doc2 = _a.sent();
                        if (doc2 == null || !doc2.exists) {
                            throw Error("Failed to fetch category '" + categoryId + "'");
                        }
                        return [2 /*return*/, doc2];
                }
            });
        });
    };
    StoreService.prototype.fetchCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchCategory called');
                        return [4 /*yield*/, this.projectRef
                                .collection(draftSuffix(Collection.Category, this.isDraft))
                                .doc(categoryId)
                                .get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch category '" + categoryId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.registerFirebaseCloudMessageToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var collectionRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] registerFirebaseCloudMessageToken called');
                        collectionRef = this.store
                            .collection(Collection.Invocation)
                            .doc(Document.SubscribeNotification)
                            .collection(this.projectID);
                        return [4 /*yield*/, collectionRef.doc(token).set({})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefCategoryList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var snapshot, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefCategoryList called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.chiefCategoryRef.orderBy(SectionFieldPath.orderIndex).get()];
                    case 2:
                        snapshot = _a.sent();
                        return [2 /*return*/, snapshot.docs];
                    case 3:
                        e_3 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchAllChiefArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchAllChiefArticles called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.chiefArticleRef.orderBy(ArticleFieldPath.orderIndex).get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_4 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchAllChangelogArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchAllChangelogArticles called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.changelogArticleRef.orderBy(ArticleFieldPath.orderIndex).get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_5 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefCategory called');
                        return [4 /*yield*/, this.chiefCategoryRef.doc(categoryId).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch category '" + categoryId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefSectionsByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefSectionsByCategoryId called');
                        return [4 /*yield*/, this.chiefSectionRef
                                .where(SectionFieldPath.category, '==', categoryId)
                                .orderBy(SectionFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchOrphanArticlesByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchOrphanArticlesByCategoryId called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.chiefArticleRef
                                .where(ArticleFieldPath.Category, '==', categoryId)
                                .where(ArticleFieldPath.Section, '==', null)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_6 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogSectionsByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChangelogSectionsByCategoryId called');
                        return [4 /*yield*/, this.changelogSectionRef
                                .where(SectionFieldPath.category, '==', categoryId)
                                .orderBy(SectionFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchOrphanChangelogArticlesByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchOrphanChangelogArticlesByCategoryId called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.changelogArticleRef
                                .where(ArticleFieldPath.Category, '==', categoryId)
                                .where(ArticleFieldPath.Section, '==', null)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_7 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchSectionsInCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchSectionsInCategory called');
                        return [4 /*yield*/, this.projectRef
                                .collection(draftSuffix(Collection.Section, this.isDraft))
                                .where(SectionFieldPath.category, '==', categoryId)
                                .orderBy(SectionFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchArticlesInCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var querySnapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchArticlesInCategory called');
                        return [4 /*yield*/, this.projectRef
                                .collection(draftSuffix(Collection.Article, this.isDraft))
                                .where(ArticleFieldPath.Category, '==', categoryId)
                                .where(ArticleFieldPath.Section, '==', null)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 1:
                        querySnapshot = _a.sent();
                        return [2 /*return*/, querySnapshot.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefArticlesBySectionId = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChiefArticlesBySectionId called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.chiefArticleRef
                                .where(ArticleFieldPath.Section, '==', sectionId)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_8 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticlesBySectionId = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[@core/StoreService] fetchChangelogArticlesBySectionId called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.changelogArticleRef
                                .where(ArticleFieldPath.Section, '==', sectionId)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 3:
                        e_9 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchArticleListBySection = function (sectionId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var collectionPath, ids, batches, batch, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (((_a = this.permittedCategories) === null || _a === void 0 ? void 0 : _a.length) < 1)
                            return [2 /*return*/, []];
                        collectionPath = this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft));
                        ids = __spreadArrays(this.permittedCategories);
                        batches = [];
                        while (ids.length > 0) {
                            batch = ids.splice(0, 10);
                            batches.push(collectionPath
                                .where(ArticleFieldPath.Section, '==', sectionId)
                                .where('category', 'in', __spreadArrays(batch))
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()
                                .then(function (query) { return query.docs.filter(excludeDeletedItemsFilter); }));
                        }
                        _c = (_b = [].concat).apply;
                        _d = [[]];
                        return [4 /*yield*/, Promise.all(batches)];
                    case 1: return [2 /*return*/, _c.apply(_b, _d.concat([(_e.sent())]))];
                }
            });
        });
    };
    return StoreService;
}());
export { StoreService };
//# sourceMappingURL=StoreService.js.map